/**
 * Default: Modules > Mindshape Cookie Consent > Category `Maps`
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Tobias Garz
 */

// import {createJs} from '../../../../../shared/utils/load';

import SelectorEngine from '../../../../../shared/dom/selector-engine';
import EventHandler from '../../../../../shared/dom/event-handler';
import Manipulator from '../../../../../shared/dom/manipulator';

import checkCookieConsentStatus from '../../index';
import Leaflet from "../../../../vendors/leaflet/init-leaflet";

// -------
// Private
// -------

const PRIVACY_NAME = 'googlemaps';

const loadGoogleMapsApi = (src) => {
	return new Promise((resolve, reject) => {

		// check if script already exists
		const existingScript = document.querySelector(`script[src="${src}"]`);
		if (existingScript) {
			console.log(`Script already loaded: ${src}`);
			return resolve();
		}

		const script = document.createElement('script');
		script.src = src;
		script.async = true;
		script.nonce = 'ifabscript';

		EventHandler.on(script, 'load', () => {
			resolve();
		});

		EventHandler.on(script, 'error', () => {
			reject(new Error(`Script load error: ${src}`));
		});

		document.body.append(script);
	});
};


// -------
// Public
// -------

const renderElement = (element) => {
	Manipulator.removeDataAttribute(element, 'privacy');
};

const init = () => {
	const COLLECTION = SelectorEngine.find(`[data-privacy="${PRIVACY_NAME}"]`);

	// let scriptGoogleMapsApi = SelectorEngine.findOne(`#${PRIVACY_NAME}-api`);

	if(!COLLECTION.length || !checkCookieConsentStatus) {
		return;
	}

	if(window.cookieConsent.hasOption('googlemaps')) {
		for(let element of COLLECTION) {
			renderElement(element);
		}

		loadGoogleMapsApi('https://maps.googleapis.com/maps/api/js?key=AIzaSyCFBkS4ewthiM5c4YZEeU0psEJvR9eZS9o')
			.then(() => {
				Leaflet.init();
			})
			.catch(error => {
				console.error(error);
			});
	}
};

// -------
// Export
// -------

export default {
	init         : init,
	renderElement: renderElement
};

